import React from "react";
import styled from "styled-components";
import { getInitials, User } from "sweet-global";
import CaretIcon from "sweet-web/components/icons/CaretIcon";
import { fadeIn } from "sweet-web/lib/animations";
import { colors } from "sweet-web/lib/styles";
import moment from "moment";

const Wrapper = styled.div`
  width: 300px;
  padding: 10px 15px 10px 15px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGray};
  border-radius: 5px;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.08) 0 3px 10px 0;
    cursor: default;
  }
`;

const LineImage = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 20px;
  margin-right: 15px;
`;

const LineInitials = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 20px;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: ${colors.gray};
  background-color: ${colors.lighterGray};
  text-align: center;
`;

const LineText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const LineTitle = styled.h3`
  font-size: 17px;
  color: ${colors.nearBlack};
  font-weight: 600;
`;

const LineLabel = styled.p`
  font-size: 12px;
  color: ${colors.gray};
  font-weight: 500;
`;

type Props = {
  user: User;
  onClick?: () => void;
  style?: object;
};
const UserLine: React.FC<Props> = props => {
  const { user, onClick } = props;

  return (
    <Wrapper onClick={onClick}>
      {user.image && <LineImage src={user.image} />}
      {!user.image && (
        <LineInitials>
          {getInitials(`${user.firstName} ${user.lastName}`)}
        </LineInitials>
      )}
      <LineText>
        <LineTitle>
          {user.firstName} {user.lastName}
        </LineTitle>
        <LineLabel>Joined {moment.unix(user.joinedTime).fromNow()}</LineLabel>
      </LineText>
    </Wrapper>
  );
};
UserLine.defaultProps = {
  style: {},
  onClick: () => {}
};

export default UserLine;
